import { captureApiError } from '@/utils/sentry'

const BASE_URL = window.location.href.includes('localhost') ? 'https://localhost:7212/api/' : '/api/'

async function apiRequest(endpoint: string, options: RequestInit = {}): Promise<any> {
  const response = await fetch(`${BASE_URL}${endpoint}`, options)

  let data
  try {
    data = await response.json()
  } catch (e) {
    const error = new Error(`HTTP error! Status: ${response.status}`)
    captureApiError(error, { endpoint, status: response.status })
    throw error
  }

  if (!response.ok) {
    const errorMessage = data?.responseMessage ||
                        (typeof data === 'string' ? data : null) ||
                        `HTTP error! Status: ${response.status}`
    const error = new Error(errorMessage)
    captureApiError(error, { endpoint, status: response.status })
    throw error
  }

  return data
}

async function apiGet(endpoint: string): Promise<any> {
  return apiRequest(endpoint)
}

async function apiPost(endpoint: string, body: any): Promise<any> {
  return apiRequest(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(body)
  })
}

async function apiUpload(endpoint: string, formData: FormData): Promise<any> {
  return apiRequest(endpoint, {
    method: 'POST',
    body: formData
  })
}

export { apiGet, apiPost, apiUpload }
